import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SearchIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.62 18.03a9 9 0 1 1 1.41-1.41l3.68 3.67a1 1 0 0 1-1.42 1.42l-3.67-3.68ZM4 11a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default SearchIcon;
